import { useEffect, useState } from "react";

// 5 city skyline images (Unsplash IDs verified). Rotator crossfades every ~7 seconds.
const CITIES = [
  { id: "dubai",     name: "Dubai",         img: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=2000&q=80&auto=format&fit=crop" },
  { id: "london",    name: "London",        img: "https://images.unsplash.com/photo-1533929736458-ca588d08c8be?w=2000&q=80&auto=format&fit=crop" },
  { id: "new-york",  name: "New York",      img: "https://images.unsplash.com/photo-1522083165195-3424ed129620?w=2000&q=80&auto=format&fit=crop" },
  { id: "singapore", name: "Singapore",     img: "https://images.unsplash.com/photo-1508964942454-1a56651d54ac?w=2000&q=80&auto=format&fit=crop" },
  { id: "sydney",    name: "Sydney",        img: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=2000&q=80&auto=format&fit=crop" },
];

export default function HeroRotator({ overlayLinear = "linear-gradient(180deg, rgba(6,10,20,0.72) 0%, rgba(6,10,20,0.88) 60%, rgba(6,10,20,0.98) 100%)", overlayRadial = "radial-gradient(ellipse at 25% 45%, rgba(6,10,20,0.35) 0%, rgba(6,10,20,0.75) 75%)" }) {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    // preload
    CITIES.forEach((c) => { const im = new Image(); im.src = c.img; });
    const t = setInterval(() => setIdx((i) => (i + 1) % CITIES.length), 7000);
    return () => clearInterval(t);
  }, []);
  return (
    <>
      {CITIES.map((c, i) => (
        <div key={c.id} data-testid={`hero-slide-${c.id}`}
          className="absolute inset-0 transition-opacity duration-[1600ms] ease-in-out"
          style={{
            opacity: i === idx ? 1 : 0,
            backgroundImage: `${overlayLinear}, url(${c.img})`,
            backgroundSize: "cover", backgroundPosition: "center",
          }} />
      ))}
      <div className="absolute inset-0 pointer-events-none" style={{ background: overlayRadial }} />
      {/* City label + progress dots */}
      <div className="absolute bottom-6 right-6 z-10 flex items-center gap-4">
        <div className="kicker text-[10px] gold" data-testid="hero-city-name">
          {CITIES[idx].name}
        </div>
        <div className="flex gap-1.5">
          {CITIES.map((c, i) => (
            <button key={c.id} onClick={() => setIdx(i)}
              data-testid={`hero-dot-${c.id}`}
              aria-label={`Show ${c.name}`}
              className={`h-[3px] transition-all duration-500 ${i === idx ? "w-8 bg-primary" : "w-3 bg-border hover:bg-muted-foreground"}`} />
          ))}
        </div>
      </div>
    </>
  );
}
